export const filters = () => {
  const filtersContainer = document.querySelector(".js-filters");

  if (!filtersContainer) {
    return; // Exit the function if the element with class 'js-filters' doesn't exist
  }

  const filterItems = filtersContainer.querySelectorAll("[data-filter]");
  const itemsToFilter = document.querySelectorAll(".js-item-to-filter");
  
  const init = () => {
    // applyActiveFilters();
    bind();
  };

  const bind = () => {
    filterItems.forEach((item) => {
      item.addEventListener("click", function (evt) {
        evt.preventDefault();
        applyFilter(evt.target);
      });
    });
  };

  const applyFilter = (clickedFilter) => {

    filterItems.forEach((item) => {
      item.classList.remove("is-current");
    });

    clickedFilter.classList.add("is-current");

    itemsToFilter.forEach((item) => {

      // const itemTag = item.getAttribute("data-tag");
      const itemTag = item.getAttribute("data-category");

      if ( itemTag.includes(clickedFilter.getAttribute("data-filter")) ) {
        console.log(itemTag);
        item.classList.remove("u-hidden");
      } else {
        item.classList.add("u-hidden");
      }
    });


  };

  // Initialize the filters if a filter list exists
  init();

};
